import { render, staticRenderFns } from "./LiveKeyWordTimeSlicing.vue?vue&type=template&id=4305d954&scoped=true"
import script from "./LiveKeyWordTimeSlicing.vue?vue&type=script&lang=js"
export * from "./LiveKeyWordTimeSlicing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4305d954",
  null
  
)

export default component.exports